import { render } from "./qual_teacher_status.vue?vue&type=template&id=155bec99"
import script from "./qual_teacher_status.vue?vue&type=script&lang=js"
export * from "./qual_teacher_status.vue?vue&type=script&lang=js"

import "./qual_teacher_status.vue?vue&type=style&index=0&id=155bec99&lang=less"

import exportComponent from "D:\\wwwroot\\tutoredin\\online-education\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__